import api from '../token';

export const AddFornecedor = async (dados) => {
  try {
    const response = await api.post('/addFornecedor', dados);
    return response.data;
  } catch (error) {
    
    return { success: false, message: error.message };
  }
};